import { GAEvent } from './events';
import { createUndefinedObject, pushDataLayer } from './utils';

interface EmotionData {
  emotionL1?: string;
  emotionL2?: string;
  timeSpent?: number;
}

export const trackEmotionLogged = async (data: EmotionData) => {
  pushDataLayer<EmotionData>(GAEvent.EMOTION_LOGGED, data);
};

export const clearEmotionDataLayer = () => {
  const emotionDataUndefined = createUndefinedObject<EmotionData>();
  pushDataLayer<EmotionData>(`clear_${GAEvent.EMOTION_LOGGED}`, emotionDataUndefined);
};
